import type { FunctionComponent, PropsWithChildren } from 'react';
import { Redirect, Route } from 'react-router-dom';
import { pages } from '../../utils/pages';

interface PrivateRouteProps {
  path: string;
  isActive: boolean;
}

const PrivateRoute: FunctionComponent<PropsWithChildren<PrivateRouteProps>> = ({
  children,
  path,
  isActive,
}) => {
  const isReactivatePath = path === pages.CANCEL_SUBSCRIPTION_FINAL.path;
  if (!isActive && !isReactivatePath) return <Redirect to={pages.CANCEL_SUBSCRIPTION_FINAL.path} />;
  return <Route path={path}>{children}</Route>;
};

export default PrivateRoute;
